// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as AuthActions } from '../../../../auth/duck';
import type { RootState } from '../../../../index';
import AlreadyExistsMailAccount from '../component/AlreadyExistsMailAccount';

function mapStateToProps(state: RootState) {
  return {
    isAuthing: state.auth.isAuthing,
    authError: state.auth.authError,
    signUpError: state.auth.signUpError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(AuthActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AlreadyExistsMailAccount);



// WEBPACK FOOTER //
// ./src/modules/auth/auth-modals/already-exists-mail-account/container/AlreadyExistsMailAccountContainer.js